import { initializeApp } from "firebase/app";
import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import "./index.css";
import {getFirestore} from "firebase/firestore";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

const config = {
  apiKey: "AIzaSyALJhTrtmaLgJi8aa4WOGCTwQvBZW3unUE",
  authDomain: "youb-esr-app.firebaseapp.com",
  projectId: "youb-esr-app",
  storageBucket: "youb-esr-app.appspot.com",
  messagingSenderId: "89368932141",
  appId: "1:89368932141:web:aa2a00b93cdd0451472da4",
  measurementId: "G-EBNWYXW8RX",
};

// Initialize Firebase
const app = initializeApp(config);


// Initialize Cloud Firestore and get a reference to the service
export const db = getFirestore(app);


ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
//reportWebVitals();
